import {DISTRIBUTION_CONSTANTS} from '../../../constants/distribution.constants';
import ViewHelpers from '../../utils/view.helpers';
/**
 * Created by aviranb on 26/12/2017.
 */
import Model from '../Model';
import ReleaseNotesListModel from '../releaseNotes/ReleaseNotesListModel';
import ArtifactsModel from './ArtifactsModel';
import BuildModel from './BuildModel';
import DistributionModel from './DistributionModel';

const ARTIFACTORY_BUILDS_PATH = 'webapp/#/builds';

export default class VersionModel extends Model {

	constructor(data) {
		super(data);
		if(data) {
            this.id = data.name;
			this.description = data.description || '';
			this.created = ViewHelpers.formatDate(data.creation_date);
			this.artifactory_base_url = data.artifactory_base_url;
            this.artifacts_view_model = new ArtifactsModel(data.artifacts, data.artifactory_base_url, data.total_number_of_artifacts);
            this.raw_artifacts_data = data.artifacts;
			this.size = data.artifacts_size;
			this.archived = data.archived;
            this.spec = data.spec;
			this.release_bundle_signed_info = data.release_bundle_signed_info;
			this.state = data.state || DISTRIBUTION_CONSTANTS.BUNDLE_VERSION_STATES.OPEN;
			this.state_details = data.state_details;
            this.storing_repo = data.storing_repository;

            if(data.last_distributions.length && data.last_distributions[0]){
				this.distribution = new DistributionModel(data.last_distributions[0]);
			} else {
				this.distribution = new DistributionModel({});
			}
			if(data.release_notes){
				this.release_notes = new ReleaseNotesListModel(data.release_notes);
			}
            this.permissions = data.permissions || [];
			this.builds = this._getBuilds();
		}
	}

	_getBuilds() {
		let builds = [];
		_.filter(this.artifacts_view_model.artifacts, file => _.find(file.properties, prop => prop.key === 'build.name'))
		 .forEach(file => {
			 let buildProps = new BuildModel({});
			 _.filter(file.properties, prop => prop.key.indexOf('build') >= 0)
			  .forEach(prop => {
				  let key = prop.key.replace('.', '_');
				  buildProps[key] = prop.values[0];
			  });
			 let buildInDataArray = _.find(builds, (build) => build.build_name === buildProps.build_name);
			 if (!buildInDataArray) {
				 buildProps.url = `${this.artifactory_base_url}/${ARTIFACTORY_BUILDS_PATH}/${buildProps.build_name}/${buildProps.build_number}`;
				 buildProps.artifact_count = 1;
				 builds.push(buildProps);
			 } else {
				 buildInDataArray.artifact_count++;
			 }
		 });
		return builds;
	}

}



// WEBPACK FOOTER //
// ./modules/distribution/core/models/distribution/VersionModel.js